import type { PropsWithChildren } from "react";

import { getSpaceVariable } from "./utilities";

type WithSpaceProps = PropsWithChildren<{
    left?: number;
    right?: number;
    top?: number;
    bottom?: number;
    horizontal?: number;
    vertical?: number;
    all?: number;
}>;

export function WithSpace(props: WithSpaceProps) {
    const { children } = props;
    const left = getSpaceVariable(props.left ?? props.horizontal ?? props.all ?? 0);
    const right = getSpaceVariable(props.right ?? props.horizontal ?? props.all ?? 0);
    const top = getSpaceVariable(props.top ?? props.vertical ?? props.all ?? 0);
    const bottom = getSpaceVariable(props.bottom ?? props.vertical ?? props.all ?? 0);
    return (
        <div
            css={{ paddingLeft: left, paddingRight: right, paddingTop: top, paddingBottom: bottom }}
        >
            {children}
        </div>
    );
}
